import React, { useEffect, useState } from 'react'
import classes from './Auth.module.css'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthService } from '../../API/AuthService'
import Logo from '../../components/UI/Logo';
import { Button, FormControl, Grid, Heading, useToast } from '@chakra-ui/react';
import { generateCodeChallenge, generateCodeVerifier, generateNonce, generateState, toastError } from '../../utils/globalHelper';
import LoadingPage from '../LoadingPage/LoadingPage';
import { useGlobalStore } from '../../store/globalStore';

function Auth() {
    const toast = useToast()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isProcessing, setIsProcessing] = useState(false)
    const setUser = useGlobalStore(state => state.setUser)

    useEffect(() => {
        async function auth() {
            setIsProcessing(true)

            const code = searchParams.get("code")
            const state = searchParams.get("state")
            const codeVerifier = sessionStorage.getItem('code_verifier')

            if (state !== sessionStorage.getItem('state')) {
                console.log(`WRONG state: old ${sessionStorage.getItem('state')}; new ${state}`)
                setSearchParams({})
                setIsProcessing(false)
                navigate('/auth')
                toast(toastError('Ошибка аутентификации', 'Перезагрузите страницу и попробуйте снова'))
                return
            }

            if (!code) {
                console.error("Authorization code not found in the callback URL.");
                setSearchParams({})
                setIsProcessing(false)
                navigate('/auth')
                toast(toastError('Ошибка аутентификации', 'Перезагрузите страницу и попробуйте снова'))
                return;
            }

            try {
                const response = await AuthService.token({
                    code: code,
                    code_verifier: codeVerifier
                })

                if (response?.status === 200 || response?.status === 201) {
                    setUser(response.data)
                    sessionStorage.clear()
                } else {
                    toast(toastError("Ошибка при обмене кода аутентификации"))
                    throw new Error(`Ошибка при обмене кода: ${response?.status}`)
                }
            } catch (error) {
                console.error("Произошла ошибка:", error)
                toast(toastError(
                    'Неудачная аутентификация',
                    typeof error?.data?.detail == 'string' && error.data.detail
                ))
                setSearchParams({})
                setIsProcessing(false)
                return
            }

            setIsProcessing(false)
            navigate('/')
        }

        if (searchParams.size > 0) 
            auth()
    }, [searchParams])

    const startAuth = async () => {
        // Генерация state и PKCE (code_verifier и code_challenge)
        const codeVerifier = generateCodeVerifier()
        const codeChallenge = await generateCodeChallenge(codeVerifier)
        const state = generateState()

        // Другие параметры авторизации
        const nonce = generateNonce()

        // Сохраняем sessionStorage для последующей проверки
        sessionStorage.setItem('code_verifier', codeVerifier)
        sessionStorage.setItem('state', state)

        // Формирование URL для авторизации
        const authUrl = `${process.env.REACT_APP_AUTODEP_ID_URL}/authorization` +
                        `?response_type=code` +
                        `&client_id=${process.env.REACT_APP_AUTODEP_SERVICE_ID}` +
                        `&scope=read write` +
                        `&nonce=${nonce}` +
                        `&code_challenge=${codeChallenge}` +
                        `&code_challenge_method=s256` +
                        `&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}` +
                        `&state=${state}`

        // Открытие вкладки для авторизации
        window.open(authUrl, '_self') 
    }

    return (
        isProcessing
        ?
        <LoadingPage />
        :
        <Grid className={classes.container}>
            <div className={classes.formWrapper}>
                <FormControl className={classes.form}>
                    <Logo className={classes.logo} />
                    <Heading textAlign='center' size='lg'>Умный мониторинг</Heading>
                    <Button onClick={startAuth}>
                        Войти
                    </Button>
                </FormControl>
            </div>
        </Grid>
    )
}

export default Auth
